import React from 'react';
import {connect} from 'react-redux';

import {Store} from 'spectra-logic-ui';

type Props = {
  title: string;
  subTitle: any;
  system: any;
};

// SubTitle renders the main page's subtitle which is the hostname of the system.
// It supports getting the hostname two different ways:
//  1) The passed in `subTitle` which is intended to be supplied by
//     the server when rendering `index.html`. This is used as a fallback so
//     the hostname is available when the application is not authenticated
//     (i.e. the login page) and thus it can't make a "GET /api/nodes" call.
//  2) The `system` resource in Redux. This is used so the current hostname
//     can be obtained in case it was updated after the page was rendered.
//
// The main title is also passed in so this component can update the main
// HTML header title, which includes both the title and subtitle. This is
// so the HTML header title can be updated when the hostname changes.
//
// SubTitle generation should be kept in sync with how mgmt/server/index_handler.go does it.
const SubTitle = ({title, subTitle, system}: Props) => {
  let displaySubTitle = subTitle;
  if (system && system.name) {
    const firstPart = system.name.split('.')[0];
    displaySubTitle = `(${firstPart})`;
  }

  if (!displaySubTitle) {
    return null;
  }

  document.title = `${title} ${displaySubTitle}`;
  return <>{displaySubTitle}</>;
};

const mapStateToProps = (state: Store) => {
  return {system: (state.resources.system || {}).data || {}};
};

export default connect(mapStateToProps)(SubTitle);
